import {
  BuildProductHistoriqueOptions,
  ProductHistoriquePayload
} from './product-historique.types';

const SNAPSHOT_KEYS = [
  'type',
  'nom',
  'tva_id',
  'taxes',
  'prix_unitaires',
  'result_ht',
  'result_ttc',
  'autoriser_vente_stock_vide',
  'produit_avec_numero_serie',
  'image',
  'marque_id',
  'categories_id',
  'unite_id',
  'ref_interne',
  'ref_fabricant',
  'code_barre',
  'couleur',
  'taille',
  'rayon',
  'description',
  'liste_prix',
  'information_logistique',
  'station_id',
  'client_id'
] as const;

export function createProductHistoriqueCorrelationId(): string {
  return `ph-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function normalizeProductHistoriqueSnapshot(
  raw: Record<string, unknown> | null | undefined
): Record<string, unknown> {
  if (!raw || typeof raw !== 'object') {
    return {};
  }
  const out: Record<string, unknown> = {};
  for (const key of SNAPSHOT_KEYS) {
    if (Object.prototype.hasOwnProperty.call(raw, key)) {
      out[key] = raw[key];
    }
  }
  return out;
}

export function serializeProductHistoriqueSnapshot(
  raw: Record<string, unknown> | null | undefined
): string | null {
  const normalized = normalizeProductHistoriqueSnapshot(raw);
  if (!Object.keys(normalized).length) {
    return null;
  }
  try {
    return JSON.stringify(normalized);
  } catch {
    return null;
  }
}

function readMetaString(snapshot: Record<string, unknown> | null | undefined, key: string): string | null {
  if (!snapshot) {
    return null;
  }
  const val = snapshot[key];
  if (val == null) {
    return null;
  }
  const s = String(val).trim();
  return s || null;
}

export function buildProductHistoriquePayload(
  opts: BuildProductHistoriqueOptions
): ProductHistoriquePayload {
  const avant = normalizeProductHistoriqueSnapshot(opts.snapshotAvant ?? null);
  const apres = normalizeProductHistoriqueSnapshot(opts.snapshotApres ?? null);
  const meta = Object.keys(apres).length ? apres : avant;

  return {
    station_id: opts.stationId,
    user_id: opts.userId,
    product_id: opts.productId,
    action: opts.action,
    source: opts.source,
    product_type: readMetaString(meta, 'type'),
    ref_interne: readMetaString(meta, 'ref_interne'),
    ref_fabricant: readMetaString(meta, 'ref_fabricant'),
    code_barre: readMetaString(meta, 'code_barre'),
    nom: readMetaString(meta, 'nom'),
    ancienne_valeur: serializeProductHistoriqueSnapshot(avant),
    nouvelle_valeur: serializeProductHistoriqueSnapshot(apres),
    snapshot_avant: serializeProductHistoriqueSnapshot(avant),
    snapshot_apres: serializeProductHistoriqueSnapshot(apres),
    correlation_id: opts.correlationId ?? null,
    batch_id: opts.batchId ?? null,
    commentaire: opts.commentaire ?? null
  };
}
